import React from "react";
import { useFormContext } from "react-hook-form";
import "./textArea2.css";
import classNames from "classnames";

const TextArea2 = ({
  label,
  labelInstruction,
  placeholder,
  maxLength,
  name,
  required = false,
  disabled = false,
  className = "",
  containerClassName = "",
  labelClassName = "",
  instructionsClassName = "",
  header = null // Para ageragr cabeceras custom
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <div className={classNames("input-text", containerClassName)}>
      {label && (
        <label className={classNames("input-label", labelClassName)}>
          {label}
        </label>
      )}
      {labelInstruction && (
        <label
          className={classNames("input-instruction", instructionsClassName)}
        >
          {labelInstruction}
        </label>
      )}
      {header}
      <textarea
        disabled={disabled}
        placeholder={placeholder}
        className={`textarea ${className}`}
        maxLength={maxLength}
        {...register(name, {
          required: required && "Este campo es obligatorio",
        })}
      />
      {errors[name] ? (
        <span className="input-error">{errors[name].message}</span>
      ):
      <span className="input-error">&nbsp;</span>}
    </div>
  );
};

export default TextArea2;
